<template>
  <div class="signature-container">
    <canvas 
      ref="canvas" 
      class="signature-canvas"
      @mousedown="startDrawing"
      @mousemove="draw"
      @mouseup="stopDrawing"
      @mouseleave="stopDrawing"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="stopDrawing"
    ></canvas>
    <!-- <div class="signature-controls">
      <a-button type="primary" @click="clearCanvas">지우기</a-button>
      <a-button type="primary" @click="saveSignature">저장</a-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'SignatureCanvas',
  props: {
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 200
    },
    lineWidth: {
      type: Number,
      default: 2
    },
    lineColor: {
      type: String,
      default: '#000000'
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    }
  },
  data() {
    return {
      canvas: null,
      context: null,
      isDrawing: false,
      lastX: 0,
      lastY: 0
    };
  },
  mounted() {
    this.initCanvas();
  },
  methods: {
    initCanvas() {
      this.canvas = this.$refs.canvas;
      this.context = this.canvas.getContext('2d');
      
      // Set canvas size
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      
      // Set canvas background
      this.context.fillStyle = this.backgroundColor;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      
      // Set line style
      this.context.lineWidth = this.lineWidth;
      this.context.lineCap = 'round';
      this.context.strokeStyle = this.lineColor;
    },
    
    // Mouse event handlers
    startDrawing(event) {
      this.isDrawing = true;
      const rect = this.canvas.getBoundingClientRect();
      const zoom = parseFloat(window.getComputedStyle(document.body).zoom) || 1;
      this.lastX = (event.clientX - rect.left) / zoom;
      this.lastY = (event.clientY - rect.top) / zoom;
    },
    
    draw(event) {
      if (!this.isDrawing) return;
      const rect = this.canvas.getBoundingClientRect();
      const zoom = parseFloat(window.getComputedStyle(document.body).zoom) || 1;
      const currentX = (event.clientX - rect.left) / zoom;
      const currentY = (event.clientY - rect.top) / zoom;
      
      this.context.beginPath();
      this.context.moveTo(this.lastX, this.lastY);
      this.context.lineTo(currentX, currentY);
      this.context.stroke();
      
      this.lastX = currentX;
      this.lastY = currentY;
    },
    
    // Touch event handlers
    handleTouchStart(event) {
      event.preventDefault();
      if (event.touches.length !== 1) return;
      
      const touch = event.touches[0];
      const mouseEvent = new MouseEvent('mousedown', {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      this.startDrawing(mouseEvent);
    },
    
    handleTouchMove(event) {
      event.preventDefault();
      if (!this.isDrawing || event.touches.length !== 1) return;
      
      const touch = event.touches[0];
      const mouseEvent = new MouseEvent('mousemove', {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      this.draw(mouseEvent);
    },
    
    stopDrawing() {
      this.isDrawing = false;
    },
    
    clearCanvas() {
      this.context.fillStyle = this.backgroundColor;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    },
    
    saveSignature() {
      // Return base64 image data
      const signatureData = this.canvas.toDataURL('image/png');
      this.$emit('save-signature', signatureData);
    }
  }
}
</script>

<style scoped>
.signature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.signature-canvas {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  touch-action: none; /* Prevents scrolling on touch devices */
}

.signature-controls {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}
</style> 